const caindoNaLua = {
  title: "CAINDO NA LUA",
  date: '01/02/2022',
  content: `Você olha pra cima
Olha pra Lua
Querendo algo mais

Deixa ela
Deixa pra lá
Ela sabe o que faz

Ela tem gravidade 
Tem sim
Que é tão importante
Pra mim
Só que não é o bastante
Pra ti

Mas não minta

A atração desse astro
É tão fraca
Pra este universo

Mas ela te puxa
Parece o inverso

Parece que ela te suga
E te deixa imerso

Você já está submerso
Está indo pro fundo
Sem resistência
Isso é até negligência

Você está iludido
E não vai ser contido

Mas eu sei que você não está sendo atraído

Você está por sua conta
E está indo profundo

O que não faz nem sentido!

A Lua é uma rocha
Não desfaz nem desmonta
E o espaço é um manto

Mas você ainda acha
Uma forma no entanto
De descer 


De cair



Se lançar






Despencar

Posso ver você se jogando

Eu te ouço gritando
Que tem algo puxando

Que é a Lua mostrando
Que ela mesma tem culpa
Por você ser quem é

Até que 


De repente


Você se esborracha!!







Se fere, se mede e se acha
O mártir principal
De um inferno astral

Mas então para ti
Tudo se encaixa

E desaba na fé
Que está recebendo
Da Lua
Da Terra
Ou de Marte

Quem sabe recebe
Até da gravidade

Um aval
Que liberte seu lado sombrio
Que a libere a pior
Das suas várias versões

Você culpa essa queda
E coloca razões
Você justifica
As suas más intenções
Em mensagens astrais
Que pra ti são lições
Pra fugir da autoria
De suas próprias ações

Mas daí você lembra
Que está machucado 
E ferido o bastante
Pra não conseguir
Não olhar para dentro
Nem olhar para o lado e seguir

Mas sim
O caminho tem volta!

Há um instante
Você olhava pra cima
Isso era o bastante

Então pode subir
Basta seguir
O brilho da Lua
Que sempre está lá

Deixa ela
Deixa pra lá
Só siga sua luz
Ela sabe o que faz

Acredite na Lua
No céu, no Sol, em Marte
Na energia do cosmos
Que sempre fez parte
Das estrelas de nêutrons
E das nebulosas
Que obras de arte

Acredite que estrelas
Tão densas, pesadas
Ainda não são capazes
De te puxar
Te atrair
Deslocar
Nem sequer elas podem
Desviar sua jornada

Mas você vai subindo
Olhando pro céu
Parece vazio

Daí olha de novo
Você já sentiu
E pode acreditar

Que viemos de estrelas
E um dia pra elas 
Nós vamos voltar

Então percebemos
Que não há mais orgulho
Pois somos pequenos demais

E por nascermos de estrelas
Nós somos pequenos e especiais

E no final você viu
Que você não caiu
Nem nunca subiu

Você esteve sempre no mesmo lugar!

E assim
Olhando pro céu
Que para ti era o pai de muitas respostas



Cai uma única e imposta lição:

Que o universo vazio
Não tem relação 
Com suas superstições

Você só descobriu
Que saiu da prisão
De suas convicções`
};

export default caindoNaLua;
